import { Button, Descriptions, Divider, Drawer, Image, Input, message, Tag, Typography } from "antd"
import moment from "moment"
import React, { useState, useEffect } from "react"
import StopOrderPaperManager from "./StopOrderPaperManager"
import ChangeMachine from "../MachineChange/ChangeMachine"
import PmChangeKnife from "./PmChangeKnife"
import PmChangeFormat from "./PmChangeFormat"
import DeleteOrder from "./DeleteOrder"
import { db } from "../../../../firebase/config"
import { doc, updateDoc } from "firebase/firestore"

const { Paragraph } = Typography
const { TextArea } = Input

export default function ShowOrderDetails({ data }) {
  const [open, setOpen] = useState(false)
  const [PMComment, setPMComment] = useState("")

  // Populate the PMComment state with an existing comment from Firestore (if any)
  useEffect(() => {
    if (data && data.PMComment) {
      setPMComment(data.PMComment)
    }
  }, [data])

  // Show / hide the drawer
  const showDrawer = () => setOpen(true)
  const onClose = () => setOpen(false)

  // Firebase update function
  const updateComment = async (id) => {
    const orderRef = doc(db, "orders", id)
    try {
      await updateDoc(orderRef, {
        PMComment: PMComment,
      })
      message.success("Comment updated successfully!")
    } catch (err) {
      message.error(err.message)
    }
  }

  // Local handler to call updateComment with the correct ID
  const handleUpdateComment = () => {
    updateComment(data.id)
  }

  return (
    <div>
      <Button size="small" onClick={showDrawer}>
        Details
      </Button>
      <Drawer
        width={550}
        title={data && data.orderNumber}
        placement="left"
        onClose={onClose}
        open={open}>
        {data && (
          <>
            <Descriptions column={1} size="small">
              <Descriptions.Item>
                <Divider orientation="left">Order</Divider>
              </Descriptions.Item>
              <Descriptions.Item label="Technical Page">
                <Image src={data.selectedProduct.technicalPage} height={50} />
              </Descriptions.Item>
              <Descriptions.Item label="Creation Date">
                {moment.unix(data.created.seconds).format("DD/MM/YYYY - HH:mm")}
              </Descriptions.Item>
              <Descriptions.Item label="Manager">
                <Tag color="blue">{data.user}</Tag>
              </Descriptions.Item>
              <Descriptions.Item label="Order ID">
                <Paragraph copyable={{ text: data.id }}>{data.id}</Paragraph>
              </Descriptions.Item>

              <Descriptions.Item>
                <Divider orientation="left">Comments</Divider>
              </Descriptions.Item>
              <Descriptions.Item label="Sales comment">{data.salesComment}</Descriptions.Item>
              <Descriptions.Item label="Designer comment">{data.designerComment}</Descriptions.Item>

              {/* The PMComment section */}
              <Descriptions.Item label="PM comment">
                <TextArea
                  value={PMComment}
                  onChange={(e) => setPMComment(e.target.value)}
                  placeholder="Type your PM comment"
                  size="small"
                />
                <Button type="primary" size="small" onClick={handleUpdateComment}>
                  Update
                </Button>
              </Descriptions.Item>

              <Descriptions.Item>
                <Divider orientation="left">Client</Divider>
              </Descriptions.Item>
              {data.clientGroup && <Descriptions.Item>{data.clientGroup}</Descriptions.Item>}
              <Descriptions.Item label="Client">{data.client.client}</Descriptions.Item>
              <Descriptions.Item label="Contact Name">{data.client.contactName}</Descriptions.Item>
              <Descriptions.Item label="Client Email">{data.client.contactEmail}</Descriptions.Item>
            </Descriptions>

            <Descriptions column={2}>
              <Descriptions.Item span={2}>
                <Divider orientation="left">Product</Divider>
              </Descriptions.Item>
              <Descriptions.Item span={2} label="Product Name">
                {data.selectedProduct.product.productName}
              </Descriptions.Item>
              <Descriptions.Item span={2} label="Format Width">
                {data.selectedProduct.formatWidth}
              </Descriptions.Item>
              <Descriptions.Item label="Material">
                {data.selectedProduct.material}
              </Descriptions.Item>
              <Descriptions.Item label="Label Count">{data.labelCount}</Descriptions.Item>
              <Descriptions.Item label="Label Width">
                {data.selectedProduct.labelWidth}
              </Descriptions.Item>
              <Descriptions.Item label="Label Height">
                {data.selectedProduct.labelHeight}
              </Descriptions.Item>
              <Descriptions.Item label="Knife Code">
                {data.selectedProduct.knifeCode}
              </Descriptions.Item>
              <Descriptions.Item label="Columns">
                {data.selectedProduct.numberOfColumns}
              </Descriptions.Item>
              <Descriptions.Item label="Plate">
                {data.selectedProduct.numberOfColumns}
              </Descriptions.Item>
              <Descriptions.Item label="Recipient">{data.recipient}</Descriptions.Item>
            </Descriptions>

            <Descriptions column={2}>
              <Descriptions.Item span={2}>
                <Divider>Action</Divider>
              </Descriptions.Item>
              <Descriptions.Item span={2}>
                {(data.selectedProduct.machine === "Cutter" ||
                  data.originalMachine === "Cutter") && (
                  <ChangeMachine orderId={data.id} order={data} />
                )}
              </Descriptions.Item>
              <Descriptions.Item span={2}>
                <StopOrderPaperManager data={data} />
              </Descriptions.Item>
              <Descriptions.Item span={2}>
                <DeleteOrder setOpen={setOpen} data={data} />
              </Descriptions.Item>
              <Descriptions.Item>
                <PmChangeKnife data={data} />
              </Descriptions.Item>
              <Descriptions.Item>
                <PmChangeFormat data={data} />
              </Descriptions.Item>
            </Descriptions>
          </>
        )}
      </Drawer>
    </div>
  )
}
